export const noDomains = "Нет свободных доменов";

export const notEnoughMoney =
  "Недостаточная сумма на балансе для создания потока. Пополните баланс.";

export const flowCreateLimit =
  "Вы достигли дневного лимита по количеству новых потоков. Чтобы расширить лимит обратитесь в саппорт";

export const pixelIdExists =
  "Для этого пользователя уже существует пиксель с таким ID.";

export const noIndexHtml = "Файл index.html не найден в архиве.";

export const noLinkInIndexHtml = "В файле index.html не найден ни один tag {link}."

export const cannotBuyFlowWithoutSubscriptionInTeam = "Вы не можете создавать поток без приобретенной подписки в команде"


export const sub7Exists =
  "Для такого юзера уже существует редиректор с таким sub7";

export const activateSubscriptionUnsufficientFunds = 'Недостаточно средств для покупки подписки на этот период'

export const unavailableTestSubscriptionActivation = "Тестовую подписку можно купить только один раз, или если еще не была приобретена другая подписка"

export const chosenSamePrelanding = "Вы выбрали тот же прелендинг";

export const teamActivateUserFullTeamError = 'Вы не можете активировать пользователя из-за ограничений вашей подписки'

export const prelandingFileCyrillicError =
  "Имя файла не должно содержать символы кириллицы.";

export const noIndexHtmlFormikError =
  "Файл index.html не был найден в корне .zip файла";

export const notRedirectorOwnerError = "Вы не являетесь владельцем редиректора";

export const noActiveAccountFound =
  "No active account found with the given credentials";

export const invalidToken = "Token is invalid";

export const emailExists = "User with this email already exists";

export const sameEmail = "New email is the same as the old one";

export const userExists = "Такой юзер уже существует";

export const have_no_rights_to_change_redirector = 'У Вас нет прав изменять данный редиректор'

export const not_member_of_your_team = 'Данный пользователь не входит в вашу команду'

export const no_permission_to_replace_owner = 'У Вас нет прав на смену на замену владельца'

export const redirectors_in_flow_do_not_belong_to_user = 'В данном потоке есть редиректоры которые принадлежат не целевому юзера. Исправьте и повторите снова.'

export const failed_to_retrieve_info_from_service = "Не удалось получить информацию с сервиса";

export const such_username_already_exists = 'Такой юзернейм уже существует'

export const addTeamUserLimitError = "Вы не можете добавить пользователя из-за ограничений вашей подписки";

export const maximum12Users = "Maximum 12 users allowed in a team.";

export const notFoundAccount = "User with given email does not exist.";
